export const mileageRunTabs: IMileageRunTabs = {
  start: 'Start',
  mileageRunReport: 'Mileage Run Report',
};

export interface IMileageRunTabs {
    start: string;
    mileageRunReport: string;
}